export default "__VITE_ASSET__D6JJPtUJ__"